"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var _OverallData = _interopRequireDefault(require("../../data/components/OverallData"));

var FormattedLangMessage = (0, _react.memo)(function (_ref) {
  var gradeType = _ref.gradeType;
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-ALT' : '';
  return _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.overall.description." + gradeType + alt
  });
});

var _default = function _default(_ref2) {
  var websiteGrade = _ref2.websiteGrade;
  var grade = websiteGrade.get('overallGrade');
  var overallData = new _OverallData.default().init(grade);
  var gradeType = overallData.gradeType;
  return _react.default.createElement(_ResultSection.default, {
    gradeType: gradeType
  }, _react.default.createElement("p", {
    className: "title"
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.overall.title." + gradeType
  })), _react.default.createElement("p", {
    className: "description"
  }, _react.default.createElement(FormattedLangMessage, {
    gradeType: gradeType
  })));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/OverallResultSection.js
// module id = 157
// module chunks = 0